import i18n from '@i18next/i18n';

export const PlaceHolderDefaultItems = {
    tbl: {
        name: i18n.t('表格占位符'),
        text: i18n.t('单击图标添加表格'),
    },
    pic: {
        name: i18n.t('图片占位符'),
        text: i18n.t('单击图标添加图片'),
    },
    txt: {
        name: i18n.t('内容占位符'),
        text: i18n.t('单击此处添加文本'),
    },
    body: {
        name: i18n.t('文本占位符'),
        text: i18n.t('单击此处添加文本'),
    },
    title: {
        name: i18n.t('标题'),
        text: i18n.t('单击此处添加标题'),
    },
    ctrTitle: {
        name: i18n.t('标题'),
        text: i18n.t('单击此处添加标题'),
    },
    subTitle: {
        name: i18n.t('副标题'),
        text: i18n.t('单击此处添加副标题'),
    },
    dt: {
        name: i18n.t('日期占位符'),
        text: i18n.t('日期'),
    },
    ftr: {
        name: i18n.t('页脚占位符'),
        text: i18n.t('页脚'),
    },
    sldNum: {
        name: i18n.t('灯片编号占位符'),
        text: i18n.t('幻灯片编号'),
    },
};

export const MasterPlaceHolderDefaultItems = {
    tbl: {
        name: i18n.t('表格占位符'),
        text: i18n.t('表格'),
    },
    pic: {
        name: i18n.t('图片占位符'),
        text: i18n.t('图片'),
    },
    txt: {
        name: i18n.t('内容占位符'),
        text: i18n.t('单击此处添加文本'),
    },
    body: {
        name: i18n.t('文本占位符'),
        text: i18n.t('单击此处编辑母版文本样式'),
    },
    title: {
        name: i18n.t('标题'),
        text: i18n.t('单击此处编辑母版标题样式'),
    },
    ctrTitle: {
        name: i18n.t('标题'),
        text: i18n.t('单击此处编辑母版标题样式'),
    },
    subTitle: {
        name: i18n.t('副标题'),
        text: i18n.t('单击此处编辑母版副标题样式'),
    },
    dt: {
        name: i18n.t('日期占位符'),
        text: i18n.t('日期'),
    },
    ftr: {
        name: i18n.t('页脚占位符'),
        text: i18n.t('页脚'),
    },
    sldNum: {
        name: i18n.t('灯片编号占位符'),
        text: i18n.t('幻灯片编号'),
    },
};
